import jwt_decode from "jwt-decode";
import { axiosClient } from "./axiosClient";
import { IBaseRespone } from "../model/respone/IBaseRespone";
import { appConst } from "../AppConst";
import Axios, { AxiosRequestConfig } from "axios";
import { MimeType } from "../types/mimeTypes";
export const objectToQueryString = (obj: any, parentKey: any): string => {
  return Object.keys(obj)
    .map((key) => {
      const value = obj[key];
      const encodedKey = parentKey
        ? `${parentKey}.${encodeURIComponent(key)}`
        : encodeURIComponent(key);

      if (
        typeof value === "object" &&
        !Array.isArray(value) &&
        value !== null
      ) {
        return objectToQueryString(value, encodedKey);
      }

      return `${encodedKey}=${encodeURIComponent(value)}`;
    })
    .join("&");
};
export const formatQueryString = (obj: any): string => {
  if (obj) {
    return objectToQueryString(obj, null);
  }
  return "";
};
type jwt_decodeResult = {
  exp: any;
};

export const clearAccessToken = () => {
  localStorage.removeItem("access_token");
};

export const clearRefreshToken = () => {
  localStorage.removeItem("refresh_token");
};
export const saveAccessToken = (access_token: string) => {
  localStorage.setItem("access_token", access_token);
};

export const saveRefreshToken = (refresh_token: string) => {
  localStorage.setItem("refresh_token", refresh_token);
};

let refreshTokenRequest: Promise<any> | null;
const checkIsTokenExpired = (): boolean => {
  // return true;
  try {
    const data: jwt_decodeResult = jwt_decode(localStorage.access_token);
    if (localStorage.access_token && data) {
      const exp = data.exp;
      if (parseInt(exp) > Math.floor(Date.now() / 1000)) {
        return false;
      } else {
        return true;
      }
    }
    return false;
  } catch (error) {
    return false;
  }
};

//Hàm này gọi refeshtoken sớm hơn exp
const REFRESH_BEFORE_EXP_SECONDS = 10 * 60;
const checkIsTokenExpired_before_exp = (): boolean => {
  try {
    const data: jwt_decodeResult = jwt_decode(localStorage.access_token);
    if (localStorage.access_token && data) {
      const exp = data.exp;
      const nowSec = Math.floor(Date.now() / 1000);
      const expSec = parseInt(exp, 10);
      if (Number.isNaN(expSec)) {
        return true;
      }
      const thresholdSec = expSec - REFRESH_BEFORE_EXP_SECONDS;
      return nowSec >= thresholdSec;
    }
    return false;
  } catch (error) {
    return false;
  }
};


const refreshToken = () => {
  return new Promise((resolve) => {
    setTimeout(async () => {
      try {
        // debugger
        let refreshTokenEnpoint = appConst.baseApiURL + "/account/token/refresh";
        if (appConst.OIDC_UNIT.toUpperCase() === "VNPT") {
            refreshTokenEnpoint = appConst.baseApiURL + "/account/token/refresh-vnpt";
        }

        const res: IBaseRespone = await axiosClient.post(
          refreshTokenEnpoint,
          {
            access_token: localStorage.access_token,
            refresh_token: localStorage.refresh_token,
          }
        );

        if (res.is_success) {
          resolve(res.data);
        } else {
          resolve(undefined);
        }
      } catch (error) {
        localStorage.removeItem("access_token");
         // debugger                                                                              
      // window.location.reload();
        resolve(undefined);
      }
    }, 1000);
  });
};

const configIfTokenExpired = async () => {
  const isTokenExpired = checkIsTokenExpired();
  if (isTokenExpired) {
    refreshTokenRequest = refreshTokenRequest
      ? refreshTokenRequest
      : refreshToken();

    const newTokens = await refreshTokenRequest;
    refreshTokenRequest = null;
    if (!newTokens) {
      // return {
      //   is_success: false,
      //   message: "Token expired.",
      // };
      clearAccessToken();
      clearRefreshToken();
      // window.location.reload();
      return;
    }
    //debugger
    const new_access_token = newTokens.access_token;
    const new_refresh_token = newTokens.refresh_token;
    saveAccessToken(new_access_token);
    saveRefreshToken(new_refresh_token);
  }
};
const apiClient = {
  get: async (path: string): Promise<IBaseRespone> => {
    const url = `${appConst.baseApiURL}/${path}`;
    try {
      await configIfTokenExpired();
      const config = {
        headers: {
          language: localStorage.getItem("language"),
          Authorization: `Bearer ${localStorage.access_token}`,
        },
      };
      const res = await axiosClient.get<any, IBaseRespone>(url, config);
      return res;
    } catch (error: any) {
      
      if (error?.response?.status === 401) {
        return {
          status_code: parseInt(error.response.status),
          is_success: false,
          message:
            "Đã hết thời gian truy cập hoặc Bạn không được phân quyền để thực hiện thao tác này.",
        };
      } else {
        return {
          status_code: error?.response?.data?.status_code,
          is_success: false,
          message: error?.response?.data?.message || "Có lỗi",
        };
      }
    }
  },
  post: async (
    path: string,
    data?: any,
    domain?: string
  ): Promise<IBaseRespone> => {
    const url = `${domain ? domain : appConst.baseApiURL}/${path}`;

    try {
      await configIfTokenExpired();
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.access_token}`,
          language: localStorage.getItem("language"),
        },
      };
      const res = await axiosClient.post<any, IBaseRespone>(url, data, config);
      return res;
    } catch (error: any) {
      //console.log('object', error);
      if (error?.response?.status === 401) {
        return {
          status_code: parseInt(error.response.status),
          is_success: false,
          message:
            "Đã hết thời gian truy cập hoặc Bạn không được phân quyền để thực hiện thao tác này.",
        };
      } else {
        return {
         status_code: error?.response?.data?.status_code,
          is_success: false,
          message: error?.response?.data?.message || "Có lỗi",
        };
      }
    }
  },
  put: async (path: string, data?: any): Promise<IBaseRespone> => {
    const url = `${appConst.baseApiURL}/${path}`;
    try {
      await configIfTokenExpired();
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.access_token}`,
          language: localStorage.getItem("language"),
        },
      };
      const res = await axiosClient.put<any, IBaseRespone>(url, data, config);
      return res;
    } catch (error: any) {
      if (error?.response?.status === 401) {
        return {
          status_code: parseInt(error.response.status),
          is_success: false,
          message:
            "Đã hết thời gian truy cập hoặc Bạn không được phân quyền để thực hiện thao tác này.",
        };
      } else {
        return {
          status_code: error?.response?.data?.status_code,
          is_success: false,
          message: error?.response?.data?.message || "Có lỗi",
        };
      }
    }
  },
  patch: async (path: string, data?: any): Promise<IBaseRespone> => {
    const url = `${appConst.baseApiURL}/${path}`;
    try {
      await configIfTokenExpired();
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.access_token}`,
          language: localStorage.getItem("language"),
        },
      };
      const res = await axiosClient.patch<any, IBaseRespone>(url, data, config);
      return res;
    } catch (error: any) {
      if (error.response.status === 401) {
        return {
          status_code: parseInt(error.response.status),
          is_success: false,
          message:
            "Đã hết thời gian truy cập hoặc Bạn không được phân quyền để thực hiện thao tác này.",
        };
      } else {
        return {
          status_code: error.response.data.code,
          is_success: false,
          message: error.response.data.message || "Có lỗi",
        };
      }
    }
  },
  delete: async (path: string): Promise<IBaseRespone> => {
    const url = `${appConst.baseApiURL}/${path}`;
    try {
      await configIfTokenExpired();
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.access_token}`,
          language: localStorage.getItem("language"),
        },
      };
      const res = await axiosClient.delete<any, IBaseRespone>(url, config);
      return res;
    } catch (error: any) {
      if (error?.response?.status === 401) {
        return {
          status_code: parseInt(error.response.status),
          is_success: false,
          message:
            "Đã hết thời gian truy cập hoặc Bạn không được phân quyền để thực hiện thao tác này.",
        };
      } else {
        return {
          status_code: error?.response?.data?.status_code,
          is_success: false,
          message: error?.response?.data?.message || "Có lỗi",
        };
      }
    }
  },
  upload: async (path: string, data?: any): Promise<IBaseRespone> => {
    const url = `${appConst.baseApiURL}/${path}`;
    try {
      await configIfTokenExpired();
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.access_token}`,
          "Content-Type": "multipart/form-data",
          language: localStorage.getItem("language"),
        },
      };
      const res = await axiosClient.post<any, IBaseRespone>(url, data, config);
      return res;
    } catch (error: any) {
      if (error?.response?.status === 401) {
        return {
          status_code: parseInt(error.response.status),
          is_success: false,
          message:
            "Đã hết thời gian truy cập hoặc Bạn không được phân quyền để thực hiện thao tác này.",
        };
      } else {
        return {
          status_code: error?.response?.data?.status_code,
          is_success: false,
          message: error?.response?.data?.message || "Có lỗi",
        };
      }
    }
  },
  downloadExcel: async (path: string, file_name: string, data?: any, domain?: string): Promise<IBaseRespone> => {
    const url = `${domain ? domain : appConst.baseApiURL}/${path}`

    try {
      await configIfTokenExpired();
      const config: AxiosRequestConfig = {
        headers: {
          Authorization: `Bearer ${localStorage.access_token}`,
          language: localStorage.getItem("language"),
        },
        responseType: "blob"
      }
      const res = await axiosClient.post(url, data, config);


      // Đọc tên file từ header 'Content-Disposition'
      // const contentDisposition = res?.headers['content-disposition'] ?? "";
      // const fileName = contentDisposition
      //     ? contentDisposition.split('filename=')[1].replace(/"/g, '')
      //     : 'exported_data.xlsx';  // Tên mặc định nếu không có header
      const fileName = "exported_data.xlsx";

      // Tạo URL tạm thời và tải file về
      const blob = new Blob([res.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.setAttribute('download', fileName);

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl); // Giải phóng URL sau khi tải

      
      return {
        status_code: 200,
        is_success: true,
        message: "File đã được tải về thành công."
      };
    } catch (error: any) {
      console.log(error);
      if (error.response.status === 403) {
        return {
          status_code: parseInt(error.response.status),
          is_success: false,
          message: "Đã hết thời gian truy cập hoặc Bạn không được phân quyền để thực hiện thao tác này."
        }
      } else {
        return {
          status_code: error?.response?.data?.status_code,
          is_success: false,
          message: error?.response?.data?.message || "Có lỗi",
        };
      }

    }
  },

  /**
   * Download file với authentication
   * @param path - API endpoint path
   * @param data - Request data  
   * @param acceptType - MIME type mong muốn
   */
  download: async (
    path: string, 
    data?: any, 
    acceptType: MimeType | string = MimeType.OCTET_STREAM
  ) => {
    const url = `${appConst.baseApiURL}/${path}`;
    try {

      //Option 1: Sử dụng axiosClient với interceptor
      await configIfTokenExpired();
      const config = {
        responseType: 'blob' as any, // Quan trọng: phải có responseType blob
        headers: {
          Authorization: `Bearer ${localStorage.access_token}`,
          'Content-Type': 'application/json',
          'Accept': acceptType,
          language: localStorage.getItem("language"),
        },
      } as AxiosRequestConfig;
      
      // const response = await axiosClient.post(url, data, config);
      const response = await Axios.post(url, data, config);
      return { 
        is_success: true,
        data: response.data, // File data dưới dạng Blob
        headers: response.headers,
        message: 'Tải file thành công'
      };
    } catch (error: any) {
      
      if (error.response?.status === 401) {
        return {
          is_success: false,
          data: null,
          message: "Đã hết thời gian truy cập hoặc Bạn không được phân quyền để thực hiện thao tác này."
        };
      } else {
        let errorMessage = 'Có lỗi xảy ra khi tải file';
        const status = error.response?.status;
        try {
          if (error.response?.data) {
            const responseData = error.response.data;
            
            // Nếu responseData là Blob (do responseType: 'blob')
            if (responseData instanceof Blob) {
        
              const blobSize = responseData.size;
              const contentType = error.response.headers?.['content-type'] || 
                                  error.response.headers?.['Content-Type'] || '';
        
              // Nếu là BadRequest hoặc Blob nhỏ hoặc Content-Type là text/json
              if (status === 400 || blobSize < 1024 * 1024 || 
                  contentType.includes('application/json') || 
                  contentType.includes('text/')) {
                try {
                  const blobClone = responseData.slice(0);
                  const text = await blobClone.text();
                  if (!text || text.trim() === '') {
                    errorMessage = `Lỗi xảy ra khi tải file (Status: ${status})`;
                  } else {
                    try {
                      const jsonData = JSON.parse(text);
                      errorMessage =jsonData.message; 
                    } catch {
                      errorMessage = text.trim();
                    }
                  }
                } catch (blobReadError) {
                  errorMessage = `Lỗi khi đọc phản hồi từ server (Status: ${status})`;
                }
              } else {
                errorMessage = 'File không hợp lệ hoặc có lỗi xảy ra';
              }
            }
            // Nếu responseData là string trực tiếp (không phải Blob)
            else if (typeof responseData === 'string') {
              errorMessage = responseData;
            } 
            // Nếu responseData là object
            else if (typeof responseData === 'object' && responseData !== null) {

              errorMessage = responseData.detail ||
                            responseData.message || 
                            responseData.value || 
                            responseData.title || 
                            responseData.error ||
                            errorMessage;
            }
          } else if (error.response?.message) {
            errorMessage = error.response.message;
          }
        } catch (parseError) {
          errorMessage = 'Error parsing error response:' + parseError?.toString();
        }
        
        return {
          is_success: false,
          data: null,
          message: errorMessage
        };
      }
    }
  },

};
export { apiClient };
